var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRTravelWithStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_r_travel_with_stars_svg__clip0_11607_803)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.325 1.343l-.35-.948-.352.948-.948.351.948.351.351.949.351-.949.949-.351-.949-.35zM10.025 3.275L9.44 1.694l-.585 1.58-1.581.586 1.58.585.586 1.58.585-1.58 1.58-.585-1.58-.585z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44 6.026l-.585-1.581-1.581-.585 1.58-.585.586-1.581.585 1.58 1.58.586-1.58.585-.585 1.58zm0-2.05a.75.75 0 01.115-.116.75.75 0 01-.115-.116.75.75 0 01-.116.116.75.75 0 01.116.115zM5.974.394l-.35.948-.95.351.95.351.35.949.351-.949.949-.351-.949-.35-.35-.95zm.55 5.63v5.199H8.14c.24 0 .433-.194.433-.433V6.459a.433.433 0 00-.433-.433H6.524zm.75.75h.55v3.699h-.55V6.776zm-1.4-.75H3.476v5.199h2.398V6.026zm-.75.75v3.699h-.898V6.776h.898zm-2.298-.75H1.209a.433.433 0 00-.433.434v4.332c0 .239.194.433.433.433h1.617V6.026zm-.75.75h-.55v3.699h.55V6.776zm.884-1.294a1.74 1.74 0 00-.018.092h.72a1.053 1.053 0 012.026 0h.72a1.759 1.759 0 00-.32-.75 1.754 1.754 0 00-2.827 0 1.752 1.752 0 00-.3.658z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_r_travel_with_stars_svg__clip0_11607_803"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgIconRTravelWithStars;